import coconino from "../coconino/config";

const config = {
  ...coconino,
    title: "Coconino County Flood Early Warning System",
    layers: {
        ...coconino.layers,
        misc: [] // remove cameras
    }

};

export default config;
